// Figma: 5701:21782 — see stories/blocks/about-hero-stats-line.stories.tsx
"use client";

import { StatCounter } from "@/components/blocks/stat-counter";

export interface AboutHeroStatsLineProps {
  employeeCount: number;
  employeesLabel: string;
  offices: string;
  worldwide: string;
  locale?: string;
}

export function AboutHeroStatsLine({
  employeeCount,
  employeesLabel,
  offices,
  worldwide,
  locale = "en",
}: AboutHeroStatsLineProps) {
  return (
    <div className="text-ds-body-sm text-grey-0 flex items-center justify-center gap-2 text-center">
      <StarBadge />
      <span className="inline-flex flex-wrap items-center justify-center gap-x-1">
        <StatCounter
          value={employeeCount}
          locale={locale}
          suffix="+"
          className="tabular-nums"
        />
        <span>{employeesLabel}</span>
        <span aria-hidden>·</span>
        <span>{offices}</span>
        <span aria-hidden>·</span>
        <span>{worldwide}</span>
      </span>
    </div>
  );
}

function StarBadge() {
  return (
    <svg
      aria-hidden
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className="shrink-0"
    >
      <rect width="16" height="16" rx="4" fill="url(#about-hero-star-stats)" />
      <path
        d="M8.00234 10.7826L10.4357 10.1659L11.4523 13.2992L8.00234 10.7826ZM13.6023 6.73255H9.31901L8.00234 2.69922L6.68568 6.73255H2.40234L5.86901 9.23255L4.55234 13.2659L8.01901 10.7659L10.1523 9.23255L13.6023 6.73255Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="about-hero-star-stats"
          x1="15.9642"
          y1="16"
          x2="-1.8083"
          y2="13.6446"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE634D" />
          <stop offset="0.2" stopColor="#F14592" />
          <stop offset="0.4" stopColor="#CE3CC9" />
          <stop offset="0.55" stopColor="#AF32E0" />
          <stop offset="0.78" stopColor="#6B20FC" />
          <stop offset="1" stopColor="#001EFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
